module.exports = __webpack_public_path__ + "static/cardText-12978b23a70bf275e00579ae84f4715b.png";